import { createSlice } from "@reduxjs/toolkit";

//sample object = {ticketNo:'34343',movieName:'Thor',date:'20th June 6:00pm'}
const initialState = {
  tickets: [],
};
const ticketsSlice = createSlice({
  name: "tickets",
  initialState,
  reducers: {
    addTicket: (state, action) => {
      state.tickets.push(action.payload);
    },
    setTickets: (state, action) => {
      state.tickets = action.payload;
    },
  },
});
export const { addTicket, setTickets } = ticketsSlice.actions;
export default ticketsSlice.reducer;
